import React from "react";
import "../styles/faq.css";
import faq from "../images/search.png";

const Faq = () => {
  return (
    <section
      id="faqs"
      className="faq_wrapper mb-5"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <p className="faq_subtitle">Your Car Buying Questions Answered</p>
            <h2 className="faq_title" itemProp="mainEntity">
              Car Buying FAQs in Kenya - Classic Motors KE
            </h2>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-sm-12 col-lg-7 mb-5 mb-lg-0">
            <div className="accordion accordion-flush" id="accordionExample">
              {/* FAQ Item 1 - Targets "best time to buy a car in Kenya" */}
              <div
                className="accordion-item"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <h3 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                    itemProp="name"
                  >
                    When is the best time to buy a car in Kenya?
                  </button>
                </h3>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div className="accordion-body" itemProp="text">
                    The optimal times to purchase vehicles in Kenya are:
                    <ul>
                      <li>
                        <strong>Year-end (Nov-Dec):</strong> When dealers offer
                        discounts to clear inventory
                      </li>
                      <li>
                        <strong>New model releases:</strong> When previous
                        models get price reductions
                      </li>
                      <li>
                        <strong>Low season (Feb-Apr):</strong> When demand is
                        typically lower
                      </li>
                    </ul>
                    At Classic Motors KE, we offer competitive pricing
                    year-round on our new, foreign used, and locally used
                    vehicles in Mombasa.
                  </div>
                </div>
              </div>

              {/* FAQ Item 2 - Targets "import car to Kenya" keywords */}
              <div
                className="accordion-item"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <h3 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                    itemProp="name"
                  >
                    What are the costs of importing a car to Kenya?
                  </button>
                </h3>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div className="accordion-body" itemProp="text">
                    Importing a car to Kenya involves:
                    <ul>
                      <li>
                        <strong>Customs duty:</strong> 25% of vehicle value
                      </li>
                      <li>
                        <strong>Excise duty:</strong> 20% for most passenger
                        vehicles
                      </li>
                      <li>
                        <strong>VAT:</strong> 16% of CIF value plus duties
                      </li>
                      <li>
                        <strong>Import declaration fee:</strong> 2.25% of CIF
                      </li>
                      <li>
                        <strong>Shipping costs:</strong> Varies by origin
                      </li>
                    </ul>
                    Our team at Classic Motors KE handles all import logistics
                    with 100% delivery record - call 0707308556 for a
                    personalized quote.
                  </div>
                </div>
              </div>

              {/* FAQ Item 3 - Targets "used car inspection Kenya" */}
              <div
                className="accordion-item"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <h3 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                    itemProp="name"
                  >
                    How do you inspect your used cars in Mombasa?
                  </button>
                </h3>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div className="accordion-body" itemProp="text">
                    Our 150-point inspection covers:
                    <ul>
                      <li>
                        <strong>Mechanical systems:</strong> Engine,
                        transmission, brakes
                      </li>
                      <li>
                        <strong>Body condition:</strong> Paint, frame, accident
                        history
                      </li>
                      <li>
                        <strong>Interior:</strong> Upholstery, electronics,
                        features
                      </li>
                      <li>
                        <strong>Documentation:</strong> Clear logbooks,
                        ownership history
                      </li>
                    </ul>
                    We're the most trusted used car dealer in Mombasa with fully
                    vetted vehicles.
                  </div>
                </div>
              </div>

              {/* FAQ Item 4 - Targets "car financing Kenya" */}
              <div
                className="accordion-item"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <h3 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                    itemProp="name"
                  >
                    What financing options are available for car buyers in
                    Kenya?
                  </button>
                </h3>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div className="accordion-body" itemProp="text">
                    Classic Motors KE offers multiple financing solutions:
                    <ul>
                      <li>
                        <strong>Bank loans:</strong> Through our partner banks
                        with competitive rates
                      </li>
                      <li>
                        <strong>Hire purchase:</strong> Flexible payment plans
                      </li>
                      <li>
                        <strong>Corporate leasing:</strong> For business fleets
                      </li>
                      <li>
                        <strong>Trade-ins:</strong> Exchange your current
                        vehicle
                      </li>
                    </ul>
                    Approval typically takes 2-3 working days for qualified
                    buyers.
                  </div>
                </div>
              </div>

              {/* FAQ Item 5 - Targets "reliable car dealers Mombasa" */}
              <div
                className="accordion-item"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <h3 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                    itemProp="name"
                  >
                    Why should I choose Classic Motors KE over other Mombasa car
                    dealers?
                  </button>
                </h3>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div className="accordion-body" itemProp="text">
                    We stand out because:
                    <ul>
                      <li>10+ years experience in Kenyan automotive market</li>
                      <li>100% delivery record on all imported vehicles</li>
                      <li>Transparent pricing with no hidden costs</li>
                      <li>After-sales support and warranty packages</li>
                      <li>Physical showroom you can visit in Mombasa</li>
                    </ul>
                    Visit us today to experience the Classic Motors KE
                    difference.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-lg-4">
            <img
              decoding="async"
              src={faq}
              alt="Trusted Car Dealer FAQs in Mombasa - Classic Motors KE"
              className="img-fluid hideOnMob"
              loading="lazy"
              width="500"
              height="500"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
